module.exports = __webpack_public_path__ + "img/Paso3.97d21149.svg";